import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Moment } from 'moment';
import { DateTimeHelper } from '../../utils/DateTimeHelper.util';

@Component
class DatetimePickerComponent extends Vue {

  @Prop({ required: true, type: [String, Date, Object] })
  value: string | Date | Moment;

  @Prop({ default: '', type: [String] })
  title: string | Date | Moment;

  dtIsDateMenu: boolean;
  dtIsTimeMetnu: boolean;
  localTime: string | any | null;
  localDate: string | any | null;
  /**
   *
   */
  constructor() {
    super();
    this.dtIsDateMenu = false;
    this.dtIsTimeMetnu = false;
    this.localTime = null;
    this.localDate = null;
  }
  get coLocale(): string {
    return this.$i18n.locale;
  }
  get vDateModel(): string {
    if (this.localDate === null) {
      this.localDate = this.value.toString();
    }
    return DateTimeHelper.parseDate(this.value);
  }
  get vTimeModel(): string {
    if (this.localTime === null) {
      this.localTime = DateTimeHelper.parseTime(this.value)
    }

    return DateTimeHelper.parseTime(this.value);
  }
  get coDateFormat(): string {
    return DateTimeHelper.dateTimeFormat;
  }

  handleChangeTime(time) {
    const val = DateTimeHelper.mergeDateTime(DateTimeHelper.parseISODate(this.value), time);
    this.$emit('input', val);
    this.dtIsTimeMetnu = false;
  }
  handleChangeDate(date) {
    const val = DateTimeHelper.mergeDateTime(date, this.vTimeModel);
    this.$emit('input', val);
    this.dtIsDateMenu = false;
  }
}

export default DatetimePickerComponent;


// WEBPACK FOOTER //
// ./src/components/datetime-picker/index.ts